import { render, staticRenderFns } from "./CategoryManagementModal.vue?vue&type=template&id=1fb22cf6&scoped=true&"
import script from "./CategoryManagementModal.vue?vue&type=script&lang=js&"
export * from "./CategoryManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb22cf6",
  null
  
)

export default component.exports